import { toLocaleDateString } from "./utils";

export const getCompanyName = (siteData, contractType) => {
  if (siteData) {
    return siteData["account_name_" + contractType] ? siteData["account_name_" + contractType] : null;
  }
  return null;
};

export const getVatNumber = (siteData, contractType) => {
  if (siteData) {
    return siteData["account_vat_" + contractType] ? siteData["account_vat_" + contractType] : null;
  }
  return null;
};

export const getEAN = (siteData, contractType) => {
  if (siteData) {
    return siteData["ean_" + contractType] ? siteData["ean_" + contractType] : null;
  }
  return null;
};

export const getAddressEAN = (siteData, contractType) => {
  if (siteData) {
    return siteData["ean_" + contractType + "_street"]
      ? siteData["ean_" + contractType + "_street"] +
          " " +
          siteData["ean_" + contractType + "_street_number"] +
          ", " +
          siteData["ean_" + contractType + "_city"].split(" ")[0]
      : null;
  }
  return null;
};

export const getContractStartDate = (siteData, contractType) => {
  if (siteData) {
    return siteData["start_date_elion_agreement_" + contractType]
      ? toLocaleDateString(siteData["start_date_elion_agreement_" + contractType])
      : null;
  }
  return null;
};
